/**
 * Route for `platform-fee-monthly-manual-bank-transfer`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { PlatformFeeMonthlyManualBankTransferPage } from "../features/platform-fee-monthly-manual-bank-transfer/PlatformFeeMonthlyManualBankTransferPage";

export const platformFeeMonthlyManualBankTransferRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/platform-fee-monthly-manual-bank-transfer",
	component: PlatformFeeMonthlyManualBankTransferPage,
});

export default platformFeeMonthlyManualBankTransferRoute;
